import React from "react"
import { Table } from "reactstrap"
import moment from "moment"
import "./style.css"

const StaffAttendanceTable = ({ data }) => {
  const today = moment().format("YYYY-MM-DD")

  return (
    <div className="p-0">
      <Table bordered hover responsive className="attendance-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Date</th>
            <th>In</th>
            <th>Out</th>
            <th>Remark</th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.map((item, index) => {
              const isToday = moment(item.date).format("YYYY-MM-DD") === today
              const [inTime, outTime] = item.checktime.split(",")

              return (
                <tr key={index} className={isToday ? "today-row" : ""}>
                  <th scope="row">{index + 1}</th>
                  <td>{moment(item.date).format("DD MMM YYYY")}</td>
                  <td className="text-success fw-bold">{inTime}</td>
                  <td className="text-danger fw-bold">
                    {inTime !== "-" && inTime !== outTime ? outTime : "--:--"}
                  </td>
                  <td
                    className={`fw-bold ${
                      item.remark === "On Time"
                        ? "text-success"
                        : item.remark === "Late"
                        ? "text-warning"
                        : item.remark === "Super Late"
                        ? "text-danger"
                        : item.remark === "NA"
                        ? "text-dark"
                        : ""
                    }`}
                  >
                    {item.remark}
                  </td>
                </tr>
              )
            })}
        </tbody>
      </Table>
    </div>
  )
}

export default StaffAttendanceTable
